import { normalizeGroupToken } from './groupToken';

// {3,5}: produkcyjne ID mają 3 znaki sufiksu, e2e używa 5 (patrz e2eTestData.ts).
const GROUP_GAME_ID_REGEX = /^([A-Z0-9]{2,6}-[A-Z2-7]{3,5})-(\d+)$/;

export function parseGroupGameId(gameId: string | null | undefined): { groupId: string; sequence: number } | null {
  if (!gameId) return null;
  const match = gameId.trim().toUpperCase().match(GROUP_GAME_ID_REGEX);
  if (!match) return null;
  const sequence = Number(match[2]);
  if (!Number.isFinite(sequence) || sequence < 1) return null;
  return { groupId: match[1], sequence };
}

function makeGroupGameId(groupId: string, sequence: number): string {
  const normalized = normalizeGroupToken(groupId) || groupId.trim().toUpperCase();
  const safeSequence = Number.isFinite(sequence) && sequence > 0 ? Math.floor(sequence) : 1;
  return `${normalized}-${safeSequence}`;
}

export function nextGroupGameId(groupId: string, lastGameId?: string | null): string {
  const normalized = normalizeGroupToken(groupId) || groupId.trim().toUpperCase();
  const parsed = parseGroupGameId(lastGameId || '');
  const nextSequence = parsed && parsed.groupId === normalized ? parsed.sequence + 1 : 1;
  return makeGroupGameId(normalized, nextSequence);
}

export function isValidGroupGameId(gameId: string): boolean {
  return Boolean(parseGroupGameId(gameId));
}
